"use client";

import { useMenuAccess } from '@/features/demo_menu/hooks/useMenuAccess';
import { Button } from '@/components/ui/button';

export function RouteGuard({ children }: { children: React.ReactNode }) {
  const access = useMenuAccess();
  if (access.loading) return <p role="status">Loading navigation…</p>;
  if (access.error || access.empty) return <section role="alert" className="p-6 text-foreground">
    <p>{access.error || 'No pages are available for this configuration.'}</p>
    <Button onClick={access.retry}>Retry</Button>
    <Button onClick={access.signOut}>Sign out</Button>
  </section>;
  return access.allowed ? <>{children}</> : null;
}
